<template>
    <div class="ui-content dashboard comptest">
		<div class="test-name-search cp3-test-name-search">
			<div
			class="past-test-dropdown monitor-users-search cp3-monitor-users-search cp3-search-label"
			>
				<v-text-field
				class="search-box"
				@keydown="onSearch()"
				outlined
				label="Test Name"
				v-model="search"
				append-icon="mdi-magnify"
				/>
      		</div>
   		</div>
        <div class="page-user user" v-if="tabsList && tabsList.length > 0">
            <v-tabs v-model="tab" background-color class="elevation-2 cust-tab">
                <v-tabs-slider></v-tabs-slider>

                <v-tab
                    v-for="tabData in tabsList"
                    :key="tabData.id"
                    :href="'#' + tabData.name"
                    >{{ getPluralForm(tabData.name) }}</v-tab
                >
                <v-tabs-items :touchless="true" v-model="tab">
                    <v-tab-item
                        v-for="tabData in tabsList"
                        :key="tabData.id"
                        :value="tabData.name"
                    >
                        <TestList
                            :parentId="TEST_TYPE.COMPLIMENTARY"
                            :subType="tabData.id"
                            :purchasedTest="tabData.purchasedTest"
							 :search="searchText"
                        />
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </div>
    </div>
</template>

<script>
import TestList from "@/components/coordinator/Tests/TestList.vue";
import { mapActions, mapState, mapMutations } from "vuex";
export default {
    name: "ComplimentaryTest",
    components: {
        TestList,
    },
    mounted() {
        this.modules = JSON.parse(localStorage.getItem("modules"));

        this.getSubTypes();
    },
    data() {
        return {
            tab: null,
            tabsList: [],
            modules: [],
			searchText: "",
      		search: "",
        };
    },
    methods: {
        ...mapMutations("app", ["addBreadCrumbChilde"]),
        ...mapActions({
            getTestSubTypes: "utilStore/getTestSubTypes",
        }),
        defaultData() {
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName);
            if (crd) {
                this.tab = crd.selectedTab
                    ? crd.selectedTab
                    : this.tabsList[0].name;
            }
        },
        checkSessionData() {
            let rp = this.$route; // route params
            let crd = this.getCurrentRouteDetails(rp.name);

            if (rp.params.resetPage || !crd.routeName) {
                let tabDetail = {};
                this.tabsList.map((t) => {
                    tabDetail[t.name] = {
                        page: 1,
                        orderBy: {
                            field: "test_name",
                            order: "ASC",
                        },
                    };
                });
                let routeDetails = {
                    routeName: rp.name,
                    selectedTab: this.tab,
                    tabDetails: tabDetail,
                    searchText: "",
                };
                this.setRouteDetails(routeDetails);
            }
        },
        getSubTypes() {
      let postData = {
        main_types: [this.TEST_TYPE.COMPLIMENTARY],
      };
      this.$root.showLoader = true;
      this.getTestSubTypes(postData)
        .then((response) => {
          let tabDetail = [];
          response.map((subType) => {
            let type = subType;
            if (type.module) {
                
                type.module = type.module.split(",").map((x) => parseInt(x));
                type.purchasedTest = false;
                for (let i = 0; i < this.modules.length; i++) {
    
                  if (
                    type.id &&
                    type.module.includes(this.modules[i].module_id) &&
                    this.modules[i].is_selected === 1 
                  ) {
                    type.purchasedTest = true;
                    tabDetail.push(type);
                   
                  }
                }
                if (!type.purchasedTest) {
                    tabDetail.push(type);
                    
                }
            }
          });
          tabDetail = tabDetail.filter(
            (v, i, a) => a.findIndex((t) => t.id === v.id) === i
          );

          this.tabsList = tabDetail;
          // this.$root.showLoader = false;
          this.defaultData();
          this.checkSessionData();
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
          
        getPluralForm(val) {
            if (val.substr(-4).toLowerCase() == "test") {
                return val + "s";
            }
            return val;
        },
		onSearch() {
			let routeName = this.$route.name;

			if (this.typetimeout) {
				clearTimeout(this.typetimeout);
			}
			this.typetimeout = setTimeout(() => {
				this.searchText = this.search;
				let updatedDetails = { searchText: this.searchText };
				updatedDetails.routeName = routeName;
				this.setRouteDetails(updatedDetails);
			}, 1500);
		},
    },
    watch: {
        tab(val, oldVal) {
            if (oldVal) {
                // only when tab is changed and not on page load
                let routeName = this.$route.name;
                this.setRouteDetails({ routeName, selectedTab: val,searchText:"" });
				this.searchText = "";
        		this.search = "";
            }
            let title = this.getPluralForm(val);
            this.addBreadCrumbChilde([
                {
                    text: title,
                    disabled: false,
                },
            ]);
        },
    },
};
</script>
